import {Component} from 'react';
import h from 'react-hyperscript';
import './AuthButtons.scss';
import {p} from 'Components/Typography/Typography';
import Avatar from 'Components/Header/Avatar/Avatar';
import GoogLoginButton from
  'Components/Buttons/GoogLoginButton/GoogLoginButton';
import GoogLogoutButton from
  'Components/Buttons/GoogLogoutButton/GoogLogoutButton';
import Menu from '@material-ui/core/Menu';

class AuthButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProfileDetails: null,
    };
    this.handleMenuClose = this.handleMenuClose.bind(this);
  }

  handleMenuClose() {
    this.setState({
      showProfileDetails: null,
    });
  }

  setShowProfileDetails(value) {
    this.setState({
      showProfileDetails: value,
    });
  }

  render() {
    if (this.props.isLoggedIn) {
      const imageUrl = this.props.googleUser.getBasicProfile().getImageUrl();
      return (
        h('div', {
          className: `${this.props.className} auth-buttons`,
        }, [
          h(p, {
            key: 'header__district-name',
            className: 'padding-right--md-2 nav-link header__district-name',
          }, this.props.userStatus ? this.props.userStatus.district_name : ''),

          this.props.isAdmin ?
          h('a', {
            href: '#',
            className: 'material-icons text--grey',
            onClick: (e) => {
              e.preventDefault();
              this.props.handleSettingsOpen();
            },
          }, 'settings') : null,

          h(Avatar, {
            key: 'header__avatar',
            id: 'header__avatar',
            width: '32px',
            tabIndex: 3,
            image: imageUrl,
            onClick: (e) => {
              e.preventDefault();
              this.setShowProfileDetails(e.currentTarget);
            },
          }, null),

          h(Menu, {
            id: 'header-menu',
            anchorEl: this.state.showProfileDetails,
            open: Boolean(this.state.showProfileDetails),
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            transformOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            onClose: this.handleMenuClose,
          },
          h('div', {
            className: 'flex--space-between header__menu',
          }, [
            h(Avatar, {
              key: 'profile-menu__avatar',
              className: 'col-ratio-1',
              image: imageUrl,
            }, null),

            h('div', {
              key: 'profile-menu-avatar-left_key',
              className: 'col-ratio-2',
            }, [
              h('p', {
                key: 'profile-menu__name',
                className: 'header__menu-text',
              }, this.props.googleUser.getBasicProfile().getName()),

              h('p', {
                key: 'profile-menu__email',
                className: 'header__menu-text',
              }, this.props.googleUser.getBasicProfile().getEmail()),

              h(GoogLogoutButton, {
                key: 'profile-menu__logout',
                className: 'header__menu-text header__logout',
                id: `${this.props.logoutBtnId}--profile-menu`,
                handleMenuClose: this.handleMenuClose,
                onClick: this.props.logoutClick,
              }, null),
            ]),
          ])
          ),
        ])
      );
    } else if (
      this.props.userStatus &&
      this.props.userStatus.admin_level === 'NonAdmin'
    ) {
      const imageUrl = this.props.googleUser.getBasicProfile().getImageUrl();
      return (
        h('div', {
          className: `${this.props.className} auth-buttons`,
        }, [
          h(p, {
            key: 'header__district-name',
            className: 'padding-right--md-2 nav-link',
          }, this.props.userStatus.district_name),

          h(Avatar, {
            key: 'header__avatar',
            id: 'header__avatar',
            width: '32px',
            tabIndex: 3,
            image: imageUrl,
            onClick: (e) => {
              e.preventDefault();
              this.setShowProfileDetails(e.currentTarget);
            },
          }, null),

          h(Menu, {
            id: 'header-menu',
            anchorEl: this.state.showProfileDetails,
            open: Boolean(this.state.showProfileDetails),
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            transformOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            onClose: this.handleMenuClose,
          },
          h('div', {
            className: 'flex--space-between header__menu',
          }, [
            h(Avatar, {
              key: 'profile-menu__avatar',
              className: 'col-ratio-1',
              image: imageUrl,
            }, null),

            h('div', {
              key: 'profile-menu-avatar-left_key',
              className: 'col-ratio-2',
            }, [
              h('p', {
                key: 'profile-menu__name',
                className: 'header__menu-text',
              }, this.props.googleUser.getBasicProfile().getName()),

              h('p', {
                key: 'profile-menu__email',
                className: 'header__menu-text',
              }, this.props.googleUser.getBasicProfile().getEmail()),

              h(GoogLogoutButton, {
                key: 'profile-menu__logout',
                className: 'header__menu-text header__logout',
                id: `${this.props.logoutBtnId}--profile-menu`,
                handleMenuClose: this.handleMenuClose,
                onClick: this.props.logoutClick,
              }, null),
            ]),
          ])
          ),
        ])
      );
    } else {
      return (
        h('div', {
          className: `${this.props.className} auth-buttons`,
        }, h(GoogLoginButton, {
          id: this.props.loginBtnId,
          onClick: this.props.loginClick,
        }, null)
        )
      );
    }
  }
}

export default AuthButtons;
